import React from 'react';

import './SaveButton.css';

export const SaveButton = ({ onClick, color, title, border, textColor, disabled }) => {
  const handleClick = () => {
    onClick();
  };

  const buttonStyle = {
    backgroundColor: color,
    border: border,
    color: textColor,
  };

  return (
    <div className="save-button-container">
      <button className="save-button" style={buttonStyle} disabled={disabled} onClick={handleClick}>
        <div>{title && <span className="button-title">{title}</span>}</div>
      </button>
    </div>
  );
};
